<h2 mat-dialog-title>Editing {{ data.layer.name }}</h2>
<mat-dialog-content class="geojson-dialog-content">
  <div class="geojson-changes-list">
    <h3>Changed Properties</h3>
    @if (geojsonEditorService.changesList$().length > 0) {
      <ul>
        @for (change of geojsonEditorService.changesList$(); track $index) {
          <li>
            <a href="#" (click)="openFeaturePopup(change.featureIndex); $event.preventDefault()">
              Feature #{{ change.featureIndex }} </a
            >:<br />
            <strong
              ><code>{{ displayPath(change.path) }}</code></strong
            >
            <span>from</span>
            <strong
              ><code>{{ change.originalValue }}</code></strong
            >
            <span>to</span>
            <strong
              ><code>{{ change.currentValue }}</code></strong
            >
          </li>
        }
      </ul>
    } @else {
      <p>Select a feature on the map to edit its properties</p>
    }
  </div>
  <div id="geojson-dialog-map"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="outlined" class="warn-button" (click)="close()">Cancel</button>
  <button
    matButton="filled"
    (click)="save()"
    [disabled]="geojsonEditorService.changesList$().length === 0"
  >
    Save
  </button>
  <button
    matButton="filled"
    (click)="saveNew()"
    [disabled]="geojsonEditorService.changesList$().length === 0"
  >
    Save as new layer
  </button>
</mat-dialog-actions>
